"use strict";

Page.Brk = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
	}
});
//# sourceMappingURL=brk.js.map
